import {resolveImageInstance} from "@frontend/lib/fabric-helper";
import {FIELD_TYPE_TEMPLATE_GUIDELINES} from "@frontend/constants/type-fields-of-template";
import {parseJsonData} from "@frontend/services/helpers";
import {removeObjectFromCanvas} from "@frontend/utils";
import debounce from "lodash/debounce";

export const TEMPLATE_GUIDELINES_PREFIX = 'template_guideline_';
export let isTemplateGuidelinesEnabled = false;

export function setTemplateGuidelinesEnabled(value) {
  isTemplateGuidelinesEnabled = value;
}

export async function drawTemplateGuidelines({canvas, fields}) {

  if (!isTemplateGuidelinesEnabled) return;

  const baseTemplateFields = fields.filter(({type}) => [FIELD_TYPE_TEMPLATE_GUIDELINES].includes(type));
  const linesData = getLinesData(baseTemplateFields) ?? [];

  if (linesData.length === 0) return;

  for (let guideline of linesData) {
    const img = await resolveImageInstance(guideline.src);
    img.set({
      ...guideline, lockUniScaling: true, selectable: false, evented: false
    });
    img.setCoords();
    canvas.add(img);
    canvas.bringToFront(img);
  }
  canvas.renderAll()
}

export async function redrawTemplateGuidelines(previews, isChecked) {
  setTemplateGuidelinesEnabled(isChecked);

  await Promise.all(previews.map(async ({canvas, template}) => {
    removeObjectFromCanvas(canvas, TEMPLATE_GUIDELINES_PREFIX);

    await drawTemplateGuidelines({canvas, fields: template.fields});
  }));
}

export const updateTemplateGuidelines = debounce(function() {
  const templateGuidelines = this.getObjects().filter(object => object.id && object.id.startsWith(TEMPLATE_GUIDELINES_PREFIX));
  for (let guideline of templateGuidelines) {
    this.bringToFront(guideline);
  }
}, 250);


function getLinesData(baseTemplateFields) {
  const dataList = [];
  for (let field of baseTemplateFields) {
    const options = parseJsonData(field.options);
    dataList.push({
      id: TEMPLATE_GUIDELINES_PREFIX + field.id,
      left: Number(options['X']) || 0,
      top: Number(options['Y']) || 0,
      width: Number(options['Width']) || 0,
      height: Number(options['Height']) || 0,
      src: options['Placeholder'],
      scaleX: Number(options['Scale']) || 1,
      scaleY: Number(options['Scale']) || 1,

    });
  }
  return dataList;
}

export function initTemplateGuidelineShowCheckbox() {
  setTemplateGuidelinesEnabled(!!localStorage.getItem('isTemplateGuidelinesEnabled'));
  const $templateGuidelineCheckbox = $('#template-guidelines');
  isTemplateGuidelinesEnabled ? $templateGuidelineCheckbox.attr('checked', 'checked') : $templateGuidelineCheckbox.removeAttr('checked');
}